import React, { ReactNode } from 'react';
import { mapBreakPoints } from '@jucy-ui/appearance';
import { useMediaQuery } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import { useTheme } from '@mui/material/styles';
import Topbar from '../../components/Topbar';

const defaultImage = 'https://storage.googleapis.com/jucy-chilwa-prod-57ad03.appspot.com/Image/jucy_page_bg_635e14d60b/jucy_page_bg_635e14d60b.jpg';

interface SideImageProps extends React.HTMLAttributes<HTMLDivElement> {
    leftContent?: ReactNode;
    imageUrl?: string;
    mainWidth?: number;
}

const SideImage: React.FC<React.PropsWithChildren<SideImageProps>> = ({
    children,
    leftContent,
    mainWidth,
    imageUrl = defaultImage,
    className,
    ...rest
}) => {
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <Box
            sx={(theme) => ({
                paddingTop: theme?.settings?.appBar?.spacer(),
                display: 'flex',
                alignItems: 'stretch',
                flexDirection: 'column',
                flex: 1,
            })}
            className={className}
            {...rest}
        >
            <Topbar />
            <Grid container component="main" sx={{ flex: 1 }}>
                <Grid
                    sx={(theme) => ({
                        zIndex: 1,
                        flexGrow: 0,
                        [theme.breakpoints.down('md')]: {
                            width: '100%',
                            flex: 1,
                        },
                    })}
                >
                    {children && (
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                position: 'sticky',
                                top: 100,
                                zIndex: 1,
                                float: 'left',
                                left: 75,
                            }}
                        >
                            {children}
                        </Box>
                    )}
                    {!isSm && (
                        <Grid
                            sx={(theme) => ({
                                flex: 1,
                                zIndex: 0,
                                position: 'sticky',
                                top: 75,
                                left: 0,
                                bottom: 0,
                                right: 0,
                                backgroundRepeat: 'no-repeat',
                                backgroundColor: theme.palette.grey[900],
                                backgroundSize: 'cover',
                                backgroundPosition: 'right',
                                height: theme?.settings?.appBar?.spacer().xs
                                    ? mapBreakPoints(theme.settings.appBar.spacer(), (space) => `calc(100vh - ${space})`)
                                    : undefined,
                                [theme.breakpoints.down('md')]: {
                                    width: '100%',
                                    flex: 0,
                                },
                                ...theme.applyStyles('light', {
                                    backgroundColor: theme.palette.grey[50],
                                }),
                            })}
                            style={{ backgroundImage: `url(${imageUrl})` }}
                        />
                    )}
                </Grid>
            </Grid>
        </Box>
    );
};

export default SideImage;
